export default __webpack_public_path__ + "static/media/space.033226b7.jpg";